import { Menu } from "lucide-react";
import { RiSearchLine } from "@remixicon/react";
import { Link } from "react-router-dom";
import logo from "@/assets/site_logo_dark.png";
import { StoreSwitcher } from "@/components/dashboard/StoreSwitcher";

interface HeaderProps {
  onMobileMenuClick: () => void;
  onSearchClick?: () => void;
}

export function Header({ onMobileMenuClick, onSearchClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur-md md:hidden">
      <div className="flex h-14 items-center justify-between gap-2 px-3">
        <div className="flex min-w-0 items-center">
          <button
            type="button"
            className="mr-1.5 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-foreground transition-colors hover:bg-foreground/[0.06]"
            onClick={onMobileMenuClick}
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" strokeWidth={2} />
          </button>
          <Link to="/dashboard" className="flex shrink-0 items-center">
            <img
              src={logo}
              alt="Sqaleshop"
              className="brand-mark h-6 w-auto max-w-none shrink-0 object-contain"
            />
          </Link>
        </div>
        <div className="flex items-center gap-1">
          {onSearchClick ? (
            <button
              type="button"
              onClick={onSearchClick}
              aria-label="Search"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full text-foreground transition-colors hover:bg-foreground/[0.06]"
            >
              <RiSearchLine className="h-5 w-5" />
            </button>
          ) : null}
          <StoreSwitcher compact />
        </div>
      </div>
    </header>
  );
}
